module.exports = __webpack_public_path__ + "static/media/block-happy.f38d2055.png";


//////////////////
// WEBPACK FOOTER
// ./src/story/sprites/block-happy.png
// module id = 84
// module chunks = 0